import type { Matrix } from './matrix-cells';
import { looksLikeScheduleItemTemplate } from './read-template';
import { looksLikeGanttPro } from './read-tasks';

/** O que o arquivo é, pelo cabeçalho — o primeiro passo do assistente de importação. */
export type ScheduleFileKind = 'GANTTPRO' | 'TEMPLATE';

/**
 * Detecta o formato pela matriz, e não pelo nome do arquivo.
 *
 * O GanttPRO primeiro: "Número de EDT" e "Nome da tarefa" não aparecem no modelo, e o
 * cabeçalho do modelo (Torre, Pavimento, Disciplina, Início, Fim) não aparece no GanttPRO,
 * então a ordem só desempata um arquivo que tenha os dois. `undefined`: não é nenhum dos dois.
 */
export function detectScheduleFileKind(matrix: Matrix): ScheduleFileKind | undefined {
  if (looksLikeGanttPro(matrix)) return 'GANTTPRO';
  if (looksLikeScheduleItemTemplate(matrix)) return 'TEMPLATE';
  return undefined;
}
